// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___XRJtO","horizontalTable":"styles__horizontalTable___2gMs0","supplierImage":"styles__supplierImage___2kLIl"};